<template>
  <div class="organisation-picker">
    <!-- Search filter -->
    <div class="col-sm-12">
      <input
        type="search"
        class="form-control"
        placeholder="Search..."
        v-model="searchText"
        aria-label="Search organisations"
      />
    </div>

    <!-- List -->
    <div class="col-sm-12">
      <div class="list-container" ref="list">
        <div
          v-for="organisation in filteredOrganisations"
          :key="organisation.id"
          class="list-item"
          :class="{ selected: organisation === selection }"
        >
          <span
            @click="selectOrganisation(organisation)"
            @keydown.enter="selectOrganisation(organisation)"
            >{{ organisation.name }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";

import { OrganisationDescriptionApiModel } from "../../../api-models";

const props = defineProps<{
  organisations: OrganisationDescriptionApiModel[];
  selection: OrganisationDescriptionApiModel | null;
}>();

const emit = defineEmits(["selection-changed"]);

const searchText = ref("");

const filteredOrganisations = computed(() => {
  if (!searchText.value) {
    return props.organisations;
  }

  const filtered = props.organisations.filter((o) =>
    o.name.toLowerCase().includes(searchText.value),
  );
  filtered.sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });

  if (!!props.selection && !filtered.includes(props.selection)) {
    emit("selection-changed", null);
  }

  return filtered;
});

const selectOrganisation = (newSelection: OrganisationDescriptionApiModel | null): void => {
  emit("selection-changed", newSelection);
};

onMounted(() => {
  emit("selection-changed", null);
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../../../styles/bootstrap/variables.less";
.organisation-picker {
  margin-top: 10px;
}

.list-container {
  max-height: 200px;
  min-height: 200px;
  overflow-y: scroll;
  margin-top: 20px;
  border: 1px solid lightgray;

  .list-item {
    margin: 10px;

    span {
      cursor: pointer;
    }

    &.selected {
      color: @link-color;
      font-weight: bold;
    }
  }
}
</style>
